"use client";

import { Globe, Headset, Trophy, Users } from "lucide-react";
import { memo } from "react";
import CountUp from "react-countup";

const STATS = [
  {
    label: "Happy Clients",
    icon: Users,
    value: 65,
    suffix: "K",
    gradient: "from-sky-500 to-blue-600",
    bgColor: "bg-sky-50 dark:bg-sky-950/30",
  },
  {
    label: "Country Tour",
    icon: Globe,
    value: 30,
    suffix: "+",
    gradient: "from-emerald-500 to-teal-600",
    bgColor: "bg-emerald-50 dark:bg-emerald-950/30",
  },
  {
    label: "Tourism Award",
    icon: Trophy,
    value: 40,
    suffix: "",
    gradient: "from-amber-500 to-orange-600",
    bgColor: "bg-amber-50 dark:bg-amber-950/30",
  },
  {
    label: "Skilled Support",
    icon: Headset,
    value: 24,
    suffix: "h",
    gradient: "from-violet-500 to-purple-600",
    bgColor: "bg-violet-50 dark:bg-violet-950/30",
  },
];

const StatItem = memo(({ stat }: { stat: (typeof STATS)[0] }) => {
  const Icon = stat.icon;

  return (
    <div
      className={`relative flex flex-col items-center justify-center gap-2  isolate `}
    >
      {/* Background Count Animation - Centered */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none z-0">
        <span
          className={`text-6xl font-black bg-linear-to-br ${stat.gradient} bg-clip-text text-transparent opacity-10 sm:text-7xl transition-all duration-500 group-hover:opacity-20 group-hover:scale-110`}
        >
          <CountUp
            end={stat.value}
            suffix={stat.suffix}
            duration={4}
            useEasing={true}
            enableScrollSpy
            scrollSpyOnce
          />
        </span>
      </div>

      <div className="relative z-10 flex flex-col items-center gap-4 transition-transform duration-300 group-hover:scale-105">
        <div
          className={`p-4 rounded-2xl bg-gradient-to-br ${stat.gradient} shadow-lg ring-4 ring-white/50 dark:ring-slate-800/50 group-hover:shadow-xl transition-shadow duration-300`}
        >
          <Icon className="h-7 w-7 md:h-8 md:w-8 text-white" strokeWidth={2} />
        </div>
        <span className="font-semibold whitespace-nowrap text-slate-700 dark:text-slate-200 text-sm md:text-base">
          {stat.label}
        </span>
      </div>
    </div>
  );
});

StatItem.displayName = "StatItem";

export function StatsSection() {
  return (
    <div className="grid grid-cols-2 gap-3 md:gap-12 lg:grid-cols-4">
      {STATS.map((stat) => (
        <StatItem key={stat.label} stat={stat} />
      ))}
    </div>
  );
}
